import axios from '../index'

/**
 * 基础信息
 * id  用户ID
 */
export function getReaderById(params) {
  return axios.post('/portal/reader/getReaderById', params)
}

/**
 * 信息 修改
 * id  用户ID
 */
export function updateReaderById(params) {
  return axios.post('/portal/reader/updateReaderById', params)
}

/**
 * 手机验证
 * imageVerification  图形验证码
 * tel    手机号
 * @returns {*}
 */
export function telVerification(params) {
  return axios.post('/portal/reader/telVerification', params)
}

/**
 * 找回密码
 * userName    手机号
 * password    新密码
 * telCode     手机验证码
 * @returns {*}
 */
export function getPasswordById(params) {
  return axios.post('/portal/reader/getPasswordById', params)
}

/**
 * 实名认证
 * @param params
 * @returns {*}
 */
export function verified(params) {
  return axios.post('/portal/reader/verified', params)
}

/** 浏览历史
 * typeId    所属端口
 * userName  用户账号信息
 */
export function listReadHistory(params) {
  return axios.get('/portal/history/listReadHistory', {params})
}

/** 删除浏览历史
 id：阅读记录ID
 */
export function deleteReadHistory(params) {
  return axios.post('/portal/history/deleteReadHistory', params)
}

/** 阅读排行
 * typeId    所属端口
 */
export function getHistoryOrder(params) {
  return axios.post('/portal/history/getHistoryOrder', params)
}


/* 收藏列表
  typeId    所属端口
  userId    用户id
*/
export function listCollection(params) {
  return axios.post('/portal/collection/listCollection', params)
}

/* 收藏排行
  typeId    所属端口
*/
export function getCollectionOrder(params) {
  return axios.post('/portal/collection/getCollectionOrder', params)
}

/* 取消收藏
  bookId    书籍id
  userId    用户id
*/
export function deleteCollectionById(params) {
  return axios.post('/portal/collection/deleteCollectionById', params)
}


/* 借阅信息
  bookId    书籍id
  userId    用户id
*/
export function listAppointment(params) {
  return axios.get('/portal/appointment/listAppointment', {params})
}

/* 取消借阅
  bookId    书籍id
  userId    用户id
*/
export function cancelAppointmentById(params) {
  return axios.post('/portal/appointment/cancelAppointmentById', params)
}

/* 借阅排行
  bookId    书籍id
  userId    用户id
*/
export function listAppointmentOrder(params) {
  return axios.post('/portal/appointment/listAppointmentOrder', params)
}

/* 读者留言
  bookId    书籍id
  userId    用户id
*/
export function addMessage(params) {
  return axios.post('/portal/message/addMessage', params)
}

/* 留言列表
  typeId
  userId    用户id
*/
export function listMessage(params) {
  return axios.post('/portal/message/listMessage', params)
}

/* 删除留言
  id        留言id
  userId    用户id
*/
export function deleteMessageById(params) {
  return axios.post('/portal/message/deleteMessageById', params)
}

/* 资源上传权限查看
  userId  读者id
  uploadPermission  上传权限，0：没有；1：有
  deletePermission  删除权限，0：没有；1：有
  validTime 有效时间，10位时间戳
*/
export function addReaderUploadPermission(params) {
  return axios.post('/admin/reader/upload/addReaderUploadPermission', params)
}

/*读者查询资源提交授权
  readerId  读者id
*/
export function getReaderUploadPermission(params) {
  return axios.get('/portal/reader/upload/getReaderUploadPermission', {params})
}

/*上传文件接口
  file      文件
  md5       文件md5
  chunk     文件上传分片数
  toPath    文件存储路径
  uid       读者id
*/
export function uploadFileOption(params) {
  return axios.post('/portal/reader/upload/uploadFileOption', params)
}

/*校验文件md5
  fileMd5  文件md5
  readerId  读者id
*/
export function checkFile(params) {
  return axios.post('/portal/reader/upload/checkFile', params)
}

/**
 * 合并文件
 * POST
 * fileName    文件名称
 * fileMd5    文件md5
 * readerId    读者id
 */
export function mergeFile(params) {
  return axios.post('/portal/reader/upload/mergeFile', params)
}

/* 购买记录查询

*/
export function getPurchaseRecordsOfCurrentUser(params) {
  return axios.get('/portal/purchaseRecord/getPurchaseRecordsOfCurrentUser', {params})
}

/* 购买记录查询

*/
export function addUploadInfo(params) {
  return axios.post('/portal/reader/upload/addUploadInfo', params)
}

/* 前台读者资源征集记录查询接口

*/
export function listLogByReaderId(params) {
  return axios.post('/portal/reader/upload/listFolder', params)
}

/* 读者资源删除接口

*/
export function deleteFileOperation(params) {
  return axios.post('/portal/reader/upload/deleteFileOperation', params)
}
